import * as FileVersionConstants from './FileVersionConstants';
import AppService from 'Global/AppService';

const VERSION_STORAGE_KEY = 'applicationVersion';

const fetchApplicationVersion = (url) => {

    return (dispatch, getState) => {
        const { isVersionFetching, isVersionFetched } = getState().VersionNumberReducer;
        if (isVersionFetching || isVersionFetched) return;

        const cachedVersion = localStorage.getItem(VERSION_STORAGE_KEY);
        if (cachedVersion) {
            dispatch(getVersionNumberSuccess({ result: { PRODUCT_VERSION: cachedVersion } }));
            return;
        }

        dispatch({ type: FileVersionConstants.FETCH_VERSION_REQUEST});

        function callback(success, err){
            console.log({success});
            if(success && success.result){
                localStorage.setItem(VERSION_STORAGE_KEY, success.result.PRODUCT_VERSION);
                dispatch(getVersionNumberSuccess(success));
            }else{
                dispatch(getVersionNumberFailure());
            }
        }

        AppService.getData(url, callback);
    }
}

const getVersionNumberSuccess = (successResponse) => {
    return { type: FileVersionConstants.FETCH_VERSION_REQUEST_SUCCESS, newState: successResponse };
}

const getVersionNumberFailure = () => {
    return { type: FileVersionConstants.FETCH_VERSION_REQUEST_FAILURE};
}

export {
    fetchApplicationVersion
}
